import { WebClient } from './client'
import type { NegocioInteligenteClient } from './types'

declare global {
  interface Window {
    NegocioInteligente?: NegocioInteligenteClient
  }
}

const client = typeof window !== 'undefined' && window.NegocioInteligente
  ? window.NegocioInteligente
  : new WebClient()

if (typeof window !== 'undefined') {
  window.NegocioInteligente = client
}

function currentScriptWebsiteId(): string | null {
  if (typeof document === 'undefined') return null
  const script = document.currentScript as HTMLScriptElement | null
  return script?.dataset.websiteId ?? null
}

const websiteId = currentScriptWebsiteId()
if (websiteId && typeof window !== 'undefined') {
  void client.init({ websiteId }).catch((error: unknown) => {
    window.dispatchEvent(new CustomEvent('ni:error', { detail: error }))
  })
}

export { WebClient, client as NegocioInteligente }
export type * from './types'
